// Routes to exclude from i18n
export const exclude = [
  '/account/callback',
  '/account/logout'
];
